import React, { useState, useEffect } from 'react';
import Loading from './components/Loading';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Footer from './components/Footer';
import Experiences from './components/Experiences';
import ScrollButton from './utils/ScrollButton';
import * as Sentry from '@sentry/react';

const App = () => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 3000); // Adjust the duration as needed

		return () => clearTimeout(timer);
	}, []);

	const handleMouseMove = (e) => {
		const overlay = e.currentTarget.querySelector('#spotlight');
		const rect = e.currentTarget.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		overlay.style.setProperty('--mouse-x', `${x}px`);
		overlay.style.setProperty('--mouse-y', `${y}px`);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div
			onMouseMove={handleMouseMove}
			className='font-sans bg-[linear-gradient(to_right_bottom,_#000000,_#030303,_#060606,_#090909,_#0c0c0c,_#110f15,_#15121b,_#181421,_#1f162d,_#281839,_#321845,_#3e164f)] min-h-screen xl:h-screen w-full overflow-x-hidden'
		>
			<div id='spotlight' className='flex-row xl:grid xl:grid-cols-9 xl:gap-3'>
				<div className='col-span-3'>
					<Hero />
				</div>
				<div className='col-span-5'>
					<About />
					<Experiences />
					<Projects />
				</div>
				<div className='col-span-1 hidden xl:block xl:sticky'>
					<Footer />
				</div>
			</div>
			<ScrollButton />
		</div>
	);
};

export default Sentry.withProfiler(App);
